module.exports = __webpack_public_path__ + "static/media/1C70124E3B71B77B.52fd5a0c.png";